module.exports = __webpack_public_path__ + "static/img/icon-4.8ae01c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-5/icon-4.png
// module id = 1jn9
// module chunks = 0